import React from 'react';
import clsx from 'clsx';
import { ImgZoom } from '../../components';
import { useCommonStyles } from '../../css';
import { useStyles } from './style';

export const TextWithImages = (props: {
  alt: string;
  src: any;
  children: any;
  wrapperClass?: any;
  reverse?: boolean;
}) => {
  const classes = useStyles();
  const commonClasses = useCommonStyles();

  return (
    <section className={commonClasses.overflowXhidden}>
      <div
        className={clsx({
          [classes.labeledImages]: true,
          [classes.flexDirectionRowReverse]: props.reverse
        })}>
        <ImgZoom
          src={props.src}
          alt={props.alt}
          className={classes.imageResponsive}
        />
        <div className={clsx(classes.textSectionWrapper, props.wrapperClass)}>
          {props.children}
        </div>
      </div>
    </section>
  );
};
